import types from 'redux/types';

export const setUserInfoAction = (parsedUserInfo) => ({
  type: types.USER_LOGIN_SET,
  payload: parsedUserInfo,
});
